import Component from '../abstracts/Component';

export default class TogglesButtonComponent extends Component {

  get SELECTORS() {
    return {
      parentButton: 'section .view-all-products',
      buttonViewAllProducts: '.js-view-all-products',
      buttonViewLessProducts: '.js-view-less-products',
      PRODUCTS_CUSTOM_CONTAINER: '.products-row-custom',
    };
  }

  static get CONSTANTS() {
    return {
      PRODUCT_LIST_URL: '/action/other-products-component',
      GET: 'GET',
    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    let ctx = this;

    //click button view more
    $(document).on('click', ctx.SELECTORS.buttonViewAllProducts, function(event) {
      event.preventDefault();

      let productsContainer = $(this).closest('section').find(ctx.SELECTORS.PRODUCTS_CUSTOM_CONTAINER);

      if(productsContainer.children().length == 0) {
        ctx.callServer($(this), ctx.getParamsObj(productsContainer), ctx.renderData.bind(ctx), ctx.hideComponent.bind(ctx));
      } else {
    	//make all products of the component visible
        $(this).closest('section').find('div.row .folded-element.folded-element-custom').removeClass('d-none');

        //hide the view all button and show button view less
        $(this).closest(ctx.SELECTORS.parentButton).find(ctx.SELECTORS.buttonViewAllProducts).addClass('d-none');
        $(this).closest(ctx.SELECTORS.parentButton).find(ctx.SELECTORS.buttonViewLessProducts).removeClass('d-none');
      }

    });

    //click button view less
    $(document).on('click', ctx.SELECTORS.buttonViewLessProducts, function(event) {
      event.preventDefault();

      let $this = $(this);
      let target = $this.closest('section');
      let preHeaderHeight = 0;
      let headerHeight = 0;

      if ($(window).width() >= 768) {
        preHeaderHeight = $('.benefit-bar.js-benefit-bar').outerHeight();
        headerHeight = $('header.main-header').outerHeight();
      }

      let scrollToPosition = target.offset().top - (preHeaderHeight + headerHeight);

      $('html,body').animate({scrollTop: scrollToPosition}, 600, function(){
    	//make some products of the component invisible
    	$this.closest('section').find('div.row .folded-element.folded-element-custom').addClass('d-none');

        //hide the view less button and show button view all
    	$this.closest(ctx.SELECTORS.parentButton).find(ctx.SELECTORS.buttonViewLessProducts).addClass('d-none');
    	$this.closest(ctx.SELECTORS.parentButton).find(ctx.SELECTORS.buttonViewAllProducts).removeClass('d-none');
      });

    });

  }

  callServer($this, paramsObj, callBackOnSuccess, callBackOnFailure) {
    let xhttp = new XMLHttpRequest();
    let params = new URLSearchParams();

    for(let key in paramsObj) {
      params.append(key, paramsObj[key]);
    }

    xhttp.open(TogglesButtonComponent.CONSTANTS.GET, TogglesButtonComponent.CONSTANTS.PRODUCT_LIST_URL + '?' + params, true);

    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        callBackOnSuccess($this, this);
      }else{
        if (this.readyState === 4) {
          console.log('Status is: ' + this.status);
          callBackOnFailure($this);
        }
      }
    };

    xhttp.ontimeout = function () {
      callBackOnFailure($this);
    };

    xhttp.onerror = function () {
      callBackOnFailure($this);
    };

    xhttp.send();
  }

  getParamsObj(productsContainer) {
    let opts = {};
    opts.codes = productsContainer.data('codes');
    opts.format = productsContainer.data('format').split(",");
    return opts;
  }

  renderData($this, data) {
    let productsContainer = $this.closest('section').find(this.SELECTORS.PRODUCTS_CUSTOM_CONTAINER);

    if(productsContainer != null){
      productsContainer.append(data.responseText);

      //hide the view all button and show button view less
      $this.closest(this.SELECTORS.parentButton).find(this.SELECTORS.buttonViewAllProducts).addClass('d-none');
      $this.closest(this.SELECTORS.parentButton).find(this.SELECTORS.buttonViewLessProducts).removeClass('d-none');
    }
  }

  hideComponent($this) {
    let productsContainer = $this.closest('section').find(this.SELECTORS.PRODUCTS_CUSTOM_CONTAINER);

    if(productsContainer != null){
      productsContainer.append = "";
    }
  }

  render() {
    this.bindEvents();
  }

}
